import {Component, OnDestroy, OnInit} from '@angular/core';
import {RxComponent} from '../../../../../core/components/common/rx.component';
import {SurchargeModel} from '../model/surcharge.model';
import {SurchargesService} from '../surcharges.service';
import {Observable, Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {NotificationService} from '../../../../../core/services/notification.service';
import {ModalService} from '../../../../../core/services/modal.service';

@Component({
    selector: 'itpx-surcharges-details',
    templateUrl: './surcharges.details.component.html',
    styleUrls: ['./surcharges.details.component.css']
})
export class SurchargesDetailsComponent extends RxComponent implements OnInit, OnDestroy {

    public initialized: boolean = false;
    public surchargeDetails: SurchargeModel = null;
    public surchargeSchema: any = {};

    private pricings: string = null;
    private surchargeRules: any = {};
    private allDictionaryObs = {};

    private routeSub: Subscription;
    private fetchSurcharge: Subscription;

    constructor(
        private surchargesService: SurchargesService,
        private route: ActivatedRoute,
        private router: Router,
        private modal: ModalService,
        private notificationService: NotificationService
    ) { super(); }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            const id = params['id'];
            this.fetchSurchargeDetails(id);
        });
    }

    fetchSurchargeDetails(id) {
        this.fetchSurcharge = Observable.combineLatest(
            this.surchargesService.fetchSurchargeDetails(id),
            this.surchargesService.getSurchargeSchema()
        ).subscribe(([details, schema]) => {
            this.surchargeDetails = details;
            this.surchargeSchema = schema;
            this.fetchAllConfigurations();
        })
    }

    fetchAllConfigurations() {
        let observables = [];
        this.surchargeSchema.rules.map((rule) => {
            const ruleType = rule && rule.value && rule.value.type;
            if (ruleType === 'config') {
                const configType = rule && rule.value && rule.value.configType;
                observables.push(
                    this.surchargesService.getConfigListByKey(configType)
                        .map(_ => _.data)
                        .map(_ => {return {type: configType, data: this.keyValueMapper(_)}}));
            }
            if (ruleType === 'dictionary') {
                const configType = rule && rule.value && rule.value.configType;
                observables.push(
                    this.surchargesService.getDictionaryByType(configType)
                        .map(_ => {return {type: configType, data: _}}));
            }
        });
        Observable.combineLatest(observables).subscribe((allData: Array<any>) => {
            allData.map(_ => {
                this.allDictionaryObs[_.type] = _.data;
            });
            this.setOptionVariables();
        });
    }

    setOptionVariables() {
        this.pricings = this.surchargeDetails.type === 'fixed' ?
            this.surchargeDetails.pricings.map(_ => `${_.currency} ${_.amount}`).join(', ') :
            (this.surchargeDetails.pricings[0] ? this.surchargeDetails.pricings[0].amount + '%' : '');

        this.surchargeDetails.rules.map((surchargeDetailsRule: any) => {
            const schemaRule = this.surchargeSchema.rules.filter(_ => _.key === surchargeDetailsRule.field)[0];
            if (schemaRule) {
                this.surchargeRules[surchargeDetailsRule.field] = {
                    ruleName: schemaRule.displayName,
                    operator: this.getOperatorFullName(surchargeDetailsRule.operator),
                    values: this.getInputSummaryByOperator(surchargeDetailsRule,schemaRule)
                };
            }
        });

        this.initialized = true;
    }

    gotoEditSurcharge() {
        this.router.navigate(['/agora/product-data/surcharges/:id/edit', { id: this.surchargeDetails.id }]);
    }

    deleteSurchargeConfirm() {
        this.modal.confirm('Delete', 'Are you sure you want to delete this surcharge?')
            .neverError()
            .bindToLifecycle(this)
            .subscribe(event => {
                this.deleteSurcharge();
            });
    }

    deleteSurcharge() {
        this.surchargesService.deleteSurcharge(this.surchargeDetails).subscribe(() => {
            this.notificationService.success('Surcharge deleted');
            this.router.navigate(['/agora/product-data/surcharges/']);
        });
    }

    getOperatorFullName(name) {
        const config = {
            'eq' : 'Equals',
            'neq' : 'Not Equals',
            'range' : 'Range',
            'in' : 'In'
        };
        if (config.hasOwnProperty(name)) {
            return config[name];
        }
        return name;
    }

    getInputSummaryByOperator(surchargeDetailsRule,schemaRule) {
        const op = surchargeDetailsRule.operator;
        const ruleType = schemaRule.value.type;
        const ruleConfigType = schemaRule.value.configType;
        let input: Array<string> = surchargeDetailsRule.value;

        if (ruleType === 'config') {
            input = surchargeDetailsRule.value.map((_) => {
                return this.allDictionaryObs[ruleConfigType][_];
            });
        }
        else if (ruleType === 'bool') {
            input = surchargeDetailsRule.value.map((_) => {
                return _ ? 'Yes' : 'No';
            });
        } else if (ruleType === 'dictionary') {
            input = surchargeDetailsRule.value.map((_) => {
                return this.allDictionaryObs[ruleConfigType][_];
            });
            return input;
        }

        const config = {
            'range' : input.join(' to '),
        };
        if (config.hasOwnProperty(op)) {
            return config[op];
        }
        return input.join(', ') || '';
    }

    keyValueMapper(data: Array<any>) {
        let result = {};
        data.map((_) => {
            result[_.configKey] = _.configValue
        });
        return result;
    }

    ngOnDestroy(): void {
        this.fetchSurcharge.unsubscribe();
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/surcharges/details/surcharges.details.component.ts